import { type FC } from 'react';
import { legalUrl } from '../lib/features.js';

/** "By … you agree to the Terms of Service and Privacy Policy" (pages on the dashboard). */
export const LegalLinks: FC<{ action: string }> = ({ action }) => (
  <p className="text-center text-[11px] text-slate-600">
    By {action} you agree to the{' '}
    <a href={legalUrl('terms')} target="_blank" rel="noopener noreferrer" className="hover:text-slate-400">Terms of Service</a> and{' '}
    <a href={legalUrl('privacy')} target="_blank" rel="noopener noreferrer" className="hover:text-slate-400">Privacy Policy</a>.
  </p>
);
